"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var Tooltip_1 = require("./Tooltip");
var StyledLabel = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "6px",
    color: "$gray12",
});
var StyledContainer = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    variants: {
        inline: {
            true: {
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "4px",
            },
        },
    },
});
var HintText = (0, react_1.styled)(Text_1.Text, {
    color: stitches_config_1.theme.colors.gray11,
});
var className = "form-label";
function FormLabel(props) {
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ inline: props.inline, className: "".concat(className, " ").concat(props.className) }, { children: [(0, jsx_runtime_1.jsxs)(StyledLabel, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.text })), props.tooltip && ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: props.tooltip }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { height: "100%", alignItems: "center", display: "flex" } }, { children: (0, jsx_runtime_1.jsx)(react_icons_1.InfoCircledIcon, {}) })) })))] }), props.hint && (0, jsx_runtime_1.jsx)(HintText, __assign({ variant: "text-sm" }, { children: props.hint }))] })));
}
exports.FormLabel = FormLabel;
FormLabel.toString = function () { return ".".concat(className); };
//# sourceMappingURL=FormLabel.js.map